import { ChangeDetectionStrategy, Component, effect, ElementRef, signal, viewChild } from '@angular/core';

@Component({
  selector: 'lib-fixed-footer',
  imports: [],
  templateUrl: './fixed-footer.component.html',
  styleUrl: './fixed-footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FixedFooterComponent {
  protected readonly resizeTrackerElement = viewChild<ElementRef<HTMLDivElement>>('resize');
  protected readonly resizedBorderBoxWidth = signal<number>(250);

  resizeTrackerElementEffect = effect(onCleanup => {
    const resizeTrackerElement = this.resizeTrackerElement();
    if (!resizeTrackerElement) {
      return;
    }

    const element = resizeTrackerElement.nativeElement;

    if (resizeTrackerElement) {
      const resizeObserver = new ResizeObserver(entries => {
        for (const entry of entries) {
          if (entry.borderBoxSize) {
            this.resizedBorderBoxWidth.set(entry.borderBoxSize[0].inlineSize);
          }
        }
      });
      resizeObserver.observe(element);

      onCleanup(() => {
        resizeObserver.unobserve(element);
        resizeObserver.disconnect();
      });
    }
  });
}
